import { cn } from "@/lib/utils"

interface PeriodSelectorProps {
	periods: readonly string[]
	selected: string
	onChange: (period: string) => void
	className?: string
}

export function PeriodSelector({ periods, selected, onChange, className }: PeriodSelectorProps) {
	return (
		<div className={cn("flex flex-wrap gap-1", className)}>
			{periods.map((period) => (
				<button
					key={period}
					onClick={() => onChange(period)}
					className={cn(
						"px-3 py-1 rounded-full text-xs font-medium transition-all",
						period === selected
							? "bg-sky-500 text-white"
							: "bg-muted text-muted-foreground hover:bg-muted/80",
					)}
				>
					{period}
				</button>
			))}
		</div>
	)
}
